import React from 'react';
import map from 'lodash/map';
import get from 'lodash/get';
import { graphql } from 'gatsby';
import { useI18next } from 'gatsby-plugin-react-i18next';

import Layout from '../components/Layout';
import Hero from '../components/Hero';
import faq from '../images/faq.jpg';
import FAQComponent from '../components/FAQ';

import faqJSON from '../faq.json';

const FAQ = () => {
  const { i18n } = useI18next();

  const currentLang = i18n.resolvedLanguage;

  return (
    <Layout pageTitle="FAQ">
      <Hero backgroundImage={faq} />
      <article className="article">
        <h1>F.A.Q.</h1>
        {map(
          faqJSON,
          (item, index) => (
            <FAQComponent
              key={index}
              question={get(item, `${currentLang}.question`)}
              answer={get(item, `${currentLang}.answer`)}
            />
          ),
        )}
      </article>
    </Layout>
  );
};

export default FAQ;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
